import {alias, createModelSchema, list} from "serializr";
import {Schema} from "@/common/Schema";
import {BaseObject} from "@/common/BaseObject";
import {ProductGroupKind} from "./ProductGroupKind";
import {Currency} from "@/modules/redactor/models/currency/Currency";

export class ProductGroup extends BaseObject {

    constructor() {
        super();
        this._kind = ProductGroupKind.NONE;
        this._order = 0;
        this._oneRow = 0;

        this._resetTime = 0;
        this._resetPrice = [];
    }

    get kind() {
        return this._kind;
    }

    set kind(value) {
        this._kind = value;
    }

    get oneRow() {
        return this._oneRow;
    }

    set oneRow(value) {
        this._oneRow = value;
    }

    get order() {
        return this._order;
    }

    set order(value) {
        this._order = value;
    }

    get resetTime() {
        return this._resetTime;
    }

    set resetTime(value) {
        this._resetTime = value;
    }

    get resetPrice() {
        return this._resetPrice;
    }

    set resetPrice(value) {
        this._resetPrice = value;
    }

    valid() {

        if (!ProductGroupKind.is(this.kind) || ProductGroupKind.isNone(this.kind)) {
            return false;
        }

        if (!Number.isInteger(this.order) || this.order < 0) {
            return false;
        }

        if (!Number.isInteger(this.resetTime) || this.resetTime < 0) {
            return false;
        }

        if (this.resetPrice && this.resetPrice.some(v => !v || !v.valid())) {
            return false;
        }

        return true;
    }

    empty() {
        return this.kind || ProductGroupKind.isNone(this.kind);
    }

    clone(target = undefined) {
        if (!target) {
            return super.clone(new ProductGroup());
        } else if (target instanceof ProductGroup) {
            return super.clone(target);
        } else {
            console.assert(false);
            return undefined;
        }
    }
}

createModelSchema(ProductGroup, {
    _kind: alias("kind", ProductGroupKind.schema()),
    _order: alias("order", Schema.primitive()),
    _resetTime: alias("reset_time", Schema.primitive()),
    _oneRow: alias("one_row", Schema.primitive()),
    _resetPrice: alias("reset_price", list(Currency.schema()))
});